import { ProductList } from "./styles";

import ProductItem from "../ProductItem";
import Video from "../Video";


export default function ProductListComponent({ title, products, video, description, children, cart_token }) {

  return (
    <ProductList>
      {(!(title == "PN")) &&
      <h1>{title}</h1>}

      {video && (<Video video={video} description={description} ></Video>)}
      {(!(title == "Outlet" || title == "PN")) && children}
      <div>
        {(products.length > 0 ) && products.map(product => (
          <ProductItem key={product.slug} product={product} cart_token={cart_token} />
        ))}

        {(products.length == 0 ) &&
          <>
            <span>Não foram localizados produtos.</span>
          </>
        }
      </div>

      {children}
    </ProductList>
  );
}
